import { Component, Input } from '@angular/core';
import { ClubModel } from '../../../core/models/app.models';

/**
 * Displays a club logo image, falling back to a branded generic crest SVG
 * when no logoUrl is provided.
 *
 * SVG crest hex values map to design tokens (unavoidable in inline template):
 *   #eaf1ff = $accent-tint   |  #cddffb = $accent-tint
 *   #9db9f0 = $accent-tint  |  #1d4ed8 = $accent
 */
@Component({
  selector: 'app-club-logo',
  template: `
    <div class="club-logo-wrapper" [style.width]="size" [style.height]="size">

      <img *ngIf="club?.logoUrl"
           [src]="club?.logoUrl"
           [alt]="club?.name"
           class="logo-img" />

      <div *ngIf="!club?.logoUrl" class="generic-crest">
        <svg viewBox="0 0 100 100" class="crest-svg" xmlns="http://www.w3.org/2000/svg">
          <!-- Base circle with brand tint -->
          <circle cx="50" cy="50" r="48"
                  fill="#eaf1ff" stroke="#cddffb" stroke-width="1.5"/>

          <!-- Shield body -->
          <path d="M50 15 L77 27 L77 59 Q77 77 50 87 Q23 77 23 59 L23 27 Z"
                fill="white" fill-opacity="0.72" stroke="#cddffb" stroke-width="1"/>

          <!-- Vertical brand stripe -->
          <path d="M44 21 L56 21 L56 83 Q53 85 50 86 Q47 85 44 83 Z"
                fill="#1d4ed8" fill-opacity="0.10"/>

          <!-- Horizontal brand stripe -->
          <rect x="25" y="46" width="50" height="10"
                fill="#1d4ed8" fill-opacity="0.08"/>

          <!-- Centre emblem ring -->
          <circle cx="50" cy="51" r="7"
                  fill="#eaf1ff" stroke="#1d4ed8"
                  stroke-width="1.5" stroke-opacity="0.35"/>

          <!-- Outer decorative ring -->
          <circle cx="50" cy="50" r="43"
                  fill="none" stroke="#9db9f0"
                  stroke-width="0.75" stroke-dasharray="3 3"/>
        </svg>
      </div>
    </div>
  `,
  styles: [`
    .club-logo-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }

    .logo-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 50%;
      background: white;
    }

    .generic-crest {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .crest-svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  `]
})
export class ClubLogoComponent {
  @Input() club?: ClubModel;
  @Input() size: string = '2.5rem';
}
